import { callAppFunction, getCookie } from '@weee-fe/utilities';
import { isSayWeeeApp } from './weeeapp';
import { IPurchaseItem } from '@/types/order';
import Constants from '@/constants/const';

export const gaAddToCart = (goodInfo: any) => {
  const params = {
    quantity: goodInfo?.quantity,
    price: goodInfo?.price,
    id: String(goodInfo?.id || goodInfo?.product_id),
    title: goodInfo?.title || goodInfo?.name
  };
  //调查ga加购出现异常的case
  if (!params?.price || !params?.quantity || !params?.id || !params?.title) {
    window.raptor?.reportLogs?.({
      event: 'ga_add_to_cart_error',
      data: {
        url: window.location.href,
        userId: getCookie(Constants.USER_ID),
        zipcode: getCookie(Constants.ZIP_CODE),
        goodInfo: params
      }
    });
  }
  if (isSayWeeeApp()) {
    callAppFunction('logEvent', {
      platform: 'GA',
      event_name: 'add_to_cart',
      event_parameter: JSON.stringify({
        value: goodInfo?.price * goodInfo?.quantity,
        currency: 'USD',
        items: [params]
      })
    });
    return;
  } else {
    window?.pixelAddToCart?.(params);
  }
};

const transformPurchaseData = (purchase: any) => {
  const _purchaseNoItems: Record<string, any> = {};
  _purchaseNoItems.value = purchase.value;
  _purchaseNoItems.tax = purchase.tax;
  _purchaseNoItems.currency = 'USD';
  _purchaseNoItems.transaction_id = String(purchase.transaction_id);
  _purchaseNoItems.items = purchase.items.map((item: any) => {
    // eslint-disable-next-line
    return {
      price: item.price,
      item_id: String(item.product_id),
      item_name: item.name,
      quantity: item.quantity
    };
  });
  // eslint-disable-next-line
  return _purchaseNoItems;
};

export const gaOrderSuccess = (order: any) => {
  const getQuantitySum = (data: IPurchaseItem[]): number => {
    return data?.length
      ? data.reduce((pre, curr) => {
          return pre + Number(curr.quantity);
        }, 0)
      : 0;
  };
  const { purchase = {} } = order;
  const _purchaseNoItems = transformPurchaseData(purchase);
  if (isSayWeeeApp()) {
    if (window?.raptor?.reportLogs) {
      window.raptor.reportLogs?.({
        event: 'ga_order_success',
        data: {
          url: window.location.href,
          userId: getCookie(Constants.USER_ID),
          zipcode: getCookie(Constants.ZIP_CODE),
          ua: window.navigator.userAgent,
          purchase: _purchaseNoItems
        }
      });
    }
    const stringifyPurchaseData = JSON.stringify(_purchaseNoItems);
    let gaParam: Record<string, any> = {
      platform: 'GA',
      event_name: 'purchase',
      new_customer: purchase?.first_order,
      event_parameter: stringifyPurchaseData
    };
    callAppFunction('logEvent', gaParam);
    if (purchase.first_order) {
      gaParam = {
        platform: 'GA',
        event_name: 'new_purchase',
        event_parameter: stringifyPurchaseData
      };
      callAppFunction('logEvent', gaParam);
    } else {
      gaParam = {
        platform: 'GA',
        event_name: 'return_purchase',
        event_parameter: stringifyPurchaseData
      };
      callAppFunction('logEvent', gaParam);
    }
    const eventParameter = {
      af_revenue: Math.round(Number(purchase.value)) + 0.02,
      af_content_type: 'product',
      af_order_id: purchase.transaction_id,
      af_currency: purchase.currency,
      af_content: JSON.stringify(purchase.items),
      af_quantity: getQuantitySum(purchase.items)
    };
    const appsFlyer = {
      platform: 'AF',
      event_name: 'af_purchase',
      event_parameter: eventParameter
    };
    callAppFunction('logEvent', appsFlyer);

    if (order?.is_d2c) {
      const appsFlyerFirst = {
        platform: 'AF',
        event_name: 'first_purchase',
        event_parameter: eventParameter
      };
      callAppFunction('logEvent', appsFlyerFirst);
    }
  } else {
    const timer = setTimeout(() => {
      if (window.pixelPurchase) {
        window.pixelPurchase?.(_purchaseNoItems);
      } else {
        console.log('pixelPurchase not found', purchase);
      }
      clearTimeout(timer);
    }, 2000);
  }
};
